<template>
  <div class="contents">
    <!-- // サウンドをページ毎に設定 -->
    <audio
      id="bgmSound"
      :src="pageId !== undefined ? `${routePath}sounds/${pageId}.mp3` : `${commonPath}sounds/bgm.mp3`"
      loop="true"
      @error="handleAudioError"
    />
    <div class="top-menu">
      <img
        class="top-menu-logo"
        :src="`${commonPath}${menuContent.logoPath}`"
        @click="openNewWindow(menuContent.homeUrl, false)"
      >
      <div class="top-menu-right">
        <div
          v-if="hideMenuButton"
          class="menu-button box-button"
          @click="openNewWindow(menuContent.mapUrl)"
        >
          <div class="button-content">
            <svg 
              class="menu-icon map"
              width="100"
              height="100"
              viewBox="0 0 43.842 64.769"
              xmlns="http://www.w3.org/2000/svg" 
            >
              <g id="link-mark">
                <circle
                  class="cls-2"
                  cx="21.921"
                  cy="22.658"
                  r="20.179"
                />
                <circle
                  class="cls-1"
                  cx="21.921"
                  cy="22.658"
                  r="10.014"
                />
                <polyline
                  class="cls-2"
                  points="37.44 35.416 21.921 59.901 6.402 35.416"
                />
              </g>
            </svg>
            <p class="menu-button-text">
              キャンパスマップに戻る
            </p>
          </div>
        </div>
        <div
          class="menu-button "
          @click="(bgmStatus) ? setBgmStatus(false) : setBgmStatus(true);"
        >
          <template v-if="bgmStatus">
            <div class="button-content circle-button volume--on">
              <i class="fas fa-volume-up" />
              <div>ON</div>
            </div>
          </template>
          <template v-else>
            <div class="button-content circle-button volume--off">
              <i class="fas fa-volume-mute" />
              <div>OFF</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="vr-scene">
      <a-scene id="scene">
        <RoomScene
          ref="room"
          :image-route-path="routePath + 'images/'"
          :glb-route-path="routePath + 'glb/'"
          :json-data="jsonData"
          @setGlbData="setGlbData"
          @loadFlag="loadFlag = true"
          @setConfirmWindow="setConfirmWindow"
          @positionChanged="positionChanged"
        />
        <!-- バス用 初期位置落下防止用床 -->
        <a-plane
          v-if="jsonData.modelName === 'bus'"
          id="busFloor"
          static-body
          position="-2 0.45 7"
          rotation="-90 0 0"
          width="2"
          height="2"
          material="opacity:0"
        />
        <!-- アバター顔動画 -->
        <template v-if="pageId === 'honkan' || pageId === '1goukan'">
          <a-assets
            id="assets-area"
          >
            <video
              v-if="loadFlag"
              id="video1"
              :src="`/face/wavehands.mp4`"
              playsinline
              autoplay
              muted
              loop
              @loadeddata="onloadedVideo"
            />
          </a-assets>
          <!-- 動画 -->
          <a-entity
            id="movie-parts"
          >
            <a-video
              v-if="loadFlag"
              :src="avatarData[pageId].videoSrc"
              :position="avatarData[pageId].position"
              :rotation="avatarData[pageId].rotation"
              width="0.6"
              height="0.34"
            />
          </a-entity>
        </template>
      </a-scene>
    </div>

    <LoadingView v-if="!loadFlag" />

    <SoundPermission
      v-if="soundPermissionFlag"
      @sound-permission="setBgmStatus(true)"
    />
    <ConfirmWindow
      v-if="confirmWindowFlag"
      :target-title="targetTitle"
      :target-url="targetUrl"
      :window-open="windowTabFlag"
      :custom-window-open="customWindowOpen"
      @close-window="confirmWindowFlag = false"
    />
  </div>
</template>

<script>
import utilsMixin from '../mixins/utils'
import LoadingView from '../components/LoadingView'
import SoundPermission from '../components/SoundPermission'
import ConfirmWindow from '../components/ConfirmWindow'
import RoomScene from '../components/RoomScene'
import settingJson from '../assets/setting-brs-nihon.json';

export default {
  name: 'BrsNihonView',
  components: {
    RoomScene,
    LoadingView,
    SoundPermission,
    ConfirmWindow
  },
  mixins: [utilsMixin],
  props: {},
  data() {
    return {
      title: '日本大学生物資源科学部',  // ページタイトル
      description: '日本大学生物資源科学部・メタバースサイト',  // ページ説明
      loadFlag: false,                                    // ロード画面用フラグ
      confirmWindowFlag: false,                           // 遷移先確認画面表示フラグ
      soundPermissionFlag: false,                         // 音声許可ウィンドウ表示フラグ
      targetTitle: '',                                    // 遷移先タイトル
      targetUrl: '',                                      // 遷移先URL
      windowTabFlag: true,                                // 別タブ起動フラグ true->別タグ
      customWindowOpen: false,                             // 特定ドメインの時に同タブ起動するフラグ true->同タブ
      allJsonData: settingJson,                           // 全てのページの設定情報
      jsonData: '',                                       // ページごとの設定情報
      pageId: this.$route.params.page,                    // ページID
      prevPageId: this.$route.query.prev,                 // 一つ前のページID
      commonPath: '/assets/brs-nihon/',               // 各データの共通パス
      routePath: '/assets/brs-nihon/',                // 各データのルートパス
      secondaryRoutePath: '/assets/brs-nihon-page/',  // 子階層の各データのルートパス
      glbData: {},                                        // 子Vueで取得したGLBデータ
      delWarpGlbList: [],                                 // ワープゾーンの土台GLB(使っていないものは削除するために保持)
      avatarData: { // アバターの情報
        'honkan': {
          videoSrc: '/face/wavehands.mp4',
          position: '8.1 1.03 -9.63',
          rotation: '0 0 0'
        },
        '1goukan': {
          videoSrc: '/face/wavehands.mp4',
          position: '-7.858 1.03 -0.49',
          rotation: '0 90 0'
        }
      },
      menuContent: {
        logoPath: 'images/menu-logo.png',
        homeUrl: '/#/brs-nihon',
        mapUrl: 'https://movie.real-virtual.co.jp/nihon-u-map/map/'
      },
      windowActive: true, // ウィンドウがアクティブかどうかのフラグ
      bgmStatusBeforeDeactivation: true, // ウィンドウが非アクティブだったときのBGMの状態
      jsonRotationY: 0, // rigカメラのY軸回転角度
      roomRig: null, // カメラリグの参照
      roomCamera: null // カメラの参照
    }
  },
  computed: {
    firstAccess() {
      // 初回アクセスフラグを取得
      return this.$store.getters['CampusStatus/getFirstAccess'];
    },
    bgmStatus() {
      // BGM許可ステータスを取得
      return this.$store.getters['CampusStatus/getBgmStatus'];
    },
    isTouchDevice() {
      // タッチデバイス判定を取得
      return this.$store.getters['CampusStatus/getTouchDeviceStatus'];
    },
    hideMenuButton() {
      // メニューのリンクボタンを隠すページを設定
      const excludedIds = ['room1', 'room2', 'room3', 'room4', 'room5', 'room6'];
      return this.pageId !== undefined && !excludedIds.includes(this.pageId);
    }
  },
  watch: {
    /*******************************************
     * BGM許可ステータスに変更がある場合
     ******************************************/
    async bgmStatus() {
      // BGMコントロール処理を呼び出し
      this.bgmControl();
    },
    /*******************************************
     * Loadフラグが更新されたらアニメーションを設定
     ******************************************/
    async loadFlag(newBool) {
      // 音声許可ポップアップを表示する判定
      if (this.firstAccess) this.soundPermissionFlag = true;
      if (newBool) {
        for (let property in this.glbData.animation) {
          // アニメーションを設定
          await this.setAnimation(property);
        }
        // リンク情報の存在しないワープGLBを非表示
        this.delWarpGlbList.forEach((elem, index) => {
          let removeGlbWarp = document.getElementById(elem);
          removeGlbWarp.setAttribute('visible', false);
        });
      }
    },
    /*******************************************
     * ウィンドウのアクティブ状態の変更を監視
     ******************************************/
    windowActive(newActiveState) {
      // ウィンドウが非アクティブになったとき
      if (!newActiveState) {
        // ウィンドウが非アクティブになる直前のBGMの状態を保存
        this.bgmStatusBeforeDeactivation = this.bgmStatus;
        // BGMをミュートにする
        this.setBgmStatus(false);
      } else {
        // ウィンドウがアクティブになったとき
        // ウィンドウが非アクティブだったときのBGMの状態に戻す
        this.setBgmStatus(this.bgmStatusBeforeDeactivation);
      }
    }
  },
  created() {
    // 出現位置を設定(建物名を設定) ※※※Custom※※※
    this.setRoomRigBrsNihon('brs-nihon', 'brs-nihon');
  },
  mounted() {
    // BGMコントロール処理を呼び出し
    this.bgmControl();
    // タイトルと説明、OGPを設定
    this.changePageContent();
    // コントロールボタン操作に必要な情報を設定
    this.jsonRotationY = this.jsonData.rig.rotation.y; // jsonDataからrigのY軸回転角度を取得しjsonRotationYに設定
    this.roomRig = this.$refs.room.$refs.rig; // roomコンポーネントからrigエレメントを取得しroomRigに設定
    this.roomCamera = this.$refs.room.$refs.camera; // roomコンポーネントからcameraエレメントを取得しroomCameraに設定
    /*******************************************
     * ウィンドウのフォーカスイベントを監視
     ******************************************/
    window.addEventListener('focus', () => {
      this.windowActive = true;
    });
    // ウィンドウのブラーイベントを監視
    window.addEventListener('blur', () => {
      this.windowActive = false;
    });
  },
  methods: {
    // 出現位置の設定
    setRoomRigBrsNihon(mainModelName, mainPageName) {
      // 直前の建物名を取得
      let prevModel = '';
      if (this.prevPageId !== undefined) prevModel = this.prevPageId.replace(/[^a-z]/gi, '');

      // -----------------------------
      // ページIDが存在しない場合（親ページ）
      // -----------------------------
      if (this.pageId === undefined) {
        console.log('ページIDが存在しない場合はメインページ表示');
        this.jsonData = this.allJsonData[mainModelName];

        if (this.prevPageId !== undefined) {
          const allowedKeys = ['comment', 'position', 'rotation'];
          const unexpectedKeys = Object.keys(this.jsonData.prevRig || {}).filter(
            key => !allowedKeys.includes(key)
          );

          if (unexpectedKeys.length > 0) {
            if (unexpectedKeys.indexOf(this.prevPageId) !== -1) {
              console.log('prevPageId に対応する rig を使用');
              this.jsonData.rig = this.jsonData.prevRig[this.prevPageId];
            } else if (unexpectedKeys.indexOf(prevModel) !== -1) {
              console.log('prevModel に対応する rig を使用');
              this.jsonData.rig = this.jsonData.prevRig[prevModel];
            }
          } else {
            console.log('prevRig 全体を使用');
            if (this.jsonData.prevRig && Object.keys(this.jsonData.prevRig).length > 0) {
              this.jsonData.rig = this.jsonData.prevRig;
            }
          }
        }

        return;
      }

      // -----------------------------
      // URL に pageId があるが JSON に存在しない場合（存在しない子ページ）
      // -----------------------------
      if (this.allJsonData[this.pageId] === undefined) {
        console.log('ページが存在しない場合はメインページを表示');
        this.jsonData = this.allJsonData[mainModelName];
        this.$router.push({ name: mainPageName });
        setTimeout(() => location.reload(), 10);
        return;
      }

      // -----------------------------
      // ページID が存在する場合（子ページ）
      // -----------------------------
      console.log('ページIDが存在する場合情報を上書き');
      this.routePath = this.secondaryRoutePath;
      this.jsonData = this.allJsonData[this.pageId];

      let prevNum = 0;
      let pageNum = this.pageId.replace(/[^0-9]/gi, '');
      if (this.prevPageId !== undefined) {
        prevNum = parseInt(this.prevPageId.replace(/[^0-9]/gi, ''), 10);
      }

      // rig の上書き
      if (this.prevPageId && this.jsonData.prevRig && this.jsonData.prevRig[this.prevPageId]) {
        // prevPageId に対応する rig があれば最優先
        this.jsonData.rig = this.jsonData.prevRig[this.prevPageId];
        console.log('prevPageId が優先されました:', this.prevPageId);

      } else if (prevModel && this.jsonData.prevRig && this.jsonData.prevRig[prevModel]) {
        // prevModel があれば次に優先
        this.jsonData.rig = this.jsonData.prevRig[prevModel];
        console.log('prevModel が優先されました:', prevModel);

      } else if (prevNum && pageNum && prevNum > pageNum) {
        //  ページ番号の比較で prevNum が大きければ prevRig 全体を適用
        this.jsonData.rig = this.jsonData.prevRig;
        console.log('prevNum > pageNum のため prevRig 全体が適用されました');

      } else {
        // pageNum >= prevNum の場合は prevRig を適用せず、通常 rig のまま
        console.log('pageNum >= prevNum のため通常の rig を使用');
        this.jsonData.rig = this.jsonData.rig;
      }

      console.log('最終的な rig:', this.jsonData.rig);
    },
    /*******************************************
     * ワープゾーンのポジション設定
     ******************************************/
    positionChanged(newPosition) {
      // 設定されているワープゾーンの数だけ繰り返しチェック
      for (let property in this.jsonData.warpList) {
        // 設定ファイルからワープゾーンのポジションを取得
        let xWarpSpot = Math.ceil(this.jsonData.warpList[property].position.x);
        let yWarpSpot = Math.ceil(this.jsonData.warpList[property].position.y);
        let zWarpSpot = Math.ceil(this.jsonData.warpList[property].position.z);
        // ワープゾーンに来たら確認ポップアップを起動(原点から±1m以内の範囲)
        if (
          (newPosition.x >= xWarpSpot - 1 && newPosition.x <= xWarpSpot + 1) &&
          (newPosition.y >= yWarpSpot - 1 && newPosition.y <= yWarpSpot + 1) &&
          (newPosition.z >= zWarpSpot - 1 && newPosition.z <= zWarpSpot + 1)
        ) {
          // ポップアップの処理を呼び出し
          this.setWarpConfirmWindow(property);
        }
      }
    },
    /*******************************************
     * OGPを設定
     ******************************************/
    // ogImagePathを生成する
    ogImagePath() {
      const uri = new URL(window.location.href);
      if (this.pageId === undefined) {
        return `${uri.origin}${this.routePath}images/og_image.png`;
      } else {
        return `${uri.origin}${this.secondaryRoutePath}images/og_image-${this.pageId}.png`;
      }
    },
    /*******************************************
     * 動画のロードが完了したとき
     ******************************************/
    async onloadedVideo(event) {
      let avatarVideo = event.target; // <video> 要素を取得
      avatarVideo.muted = true; // 動画をミュート状態にする
      try {
        await avatarVideo.play(); // 動画を再生
      } catch (err) {
        // 再生エラーの時
        console.warn('動画の再生に失敗しました:', err);
      }
    },
    /*******************************************
     * BGM許可ステータスを設定
     ******************************************/
    setBgmStatus(newBool) {
      this.$store.dispatch('CampusStatus/setBgmStatus', newBool);
      this.soundPermissionFlag = false;
      // BGMコントロール処理を呼び出し
      this.bgmControl();
    },
    /*******************************************
    * BGMの読み込みが失敗した時の設定
    *******************************************/
    handleAudioError(event) {
      const audio = event.target;
      // 読み込みできなかった場合は共通BGMに切り替え
      audio.src = `${this.commonPath}sounds/bgm.mp3`;

      // BGMがON状態なら再生
      if (this.bgmStatus) {
        audio.play().catch(() => {
          console.warn('デフォルトBGMの自動再生に失敗しました');
        });
      }
    },
    /*******************************************
     * フラグに変更があれば再生or一時停止処理
     ******************************************/
    async bgmControl() {
      const bgmSound = document.getElementById('bgmSound');
      if (!this.bgmStatus) {
        // BGMがOFF状態なら一時停止
        bgmSound.pause();
        return;
      }

      // BGMがON状態なら再生
      try {
        await bgmSound.play();
        // 初回アクセスの場合は書き換え
        if (this.firstAccess) this.$store.dispatch('CampusStatus/setFirstAccess', false);
      } catch (err) {
        console.warn('BGMの再生に失敗しました');
      }
    },
    /*******************************************
     * 子から受け取った建物データを設定
     ******************************************/
    setGlbData(glbData) {
      this.glbData = glbData;
    },
    /*******************************************
     * 別タブでURLを起動
     * 特定のURLの時は同タブで遷移
     ******************************************/
    openNewWindow(target, windw = true) {
      // 特定ドメインを設定
      const isSameTabDomain = target.includes('real-virtual.co.jp/nihon-u');

      if (isSameTabDomain) {
        // 特定ドメインの時は同タブで遷移
        location.href = target;
      } else if (windw) {
        // 別タブ起動
        window.open(target);
      } else {
        // 特定ドメインではないが、windw=false の時は同タブで遷移
        location.href = target;
        location.reload();
      }
    },
    /*******************************************
     * 画面遷移のConfirm画面呼び出し
     ******************************************/
    setConfirmWindow(target) {
      // URL形式
      if (this.jsonData.linkList[target].url.indexOf('://') === -1) {
        // 自サイトの場合ホストを設定
        this.targetUrl = window.location.protocol + '//' + window.location.host + '/#';
        this.targetUrl += this.jsonData.linkList[target].url;
        // pageIDがある場合はパラメーターに設定
        if (this.pageId !== undefined) this.targetUrl += '?prev=' + this.pageId;
        this.windowTabFlag = false;
      } else {
        // 他サイトの場合はそのままURLを設定
        this.targetUrl = this.jsonData.linkList[target].url;
      }
      // タイトルを設定
      this.targetTitle = this.jsonData.linkList[target].title;
      // confirmウィンドウを起動
      this.confirmWindowFlag = true;
    },
    /*******************************************
     * ワープのConfirm画面呼び出し
     ******************************************/
    setWarpConfirmWindow(target) {
      // URL形式
      if (this.jsonData.warpList[target].url.indexOf('://') === -1) {
        // 自サイトの場合ホストを設定
        this.targetUrl = window.location.protocol + '//' + window.location.host + '/#';
        this.targetUrl += this.jsonData.warpList[target].url;
        // pageIDがある場合はパラメーターに設定
        if (this.pageId !== undefined) this.targetUrl += '?prev=' + this.pageId;
        this.windowTabFlag = false;
      } else {
        // 他サイトの場合はそのままURLを設定
        this.targetUrl = this.jsonData.warpList[target].url;
      }
      // targetUrlに特定のドメイン(文字列)が含まれているかチェック
      if (this.targetUrl.includes('real-virtual.co.jp/nihon-u')) {
        this.customWindowOpen = true;
        this.windowTabFlag = false; // 同タブ内で処理するように設定
      } else {
        this.customWindowOpen = false // 通常の設定
      }
      // タイトルを設定
      this.targetTitle = this.jsonData.warpList[target].title;
      // confirmウィンドウを起動
      this.confirmWindowFlag = true;
    },
    /*******************************************
     * パーツごとにアニメーションを設定する
     ******************************************/
    setAnimation(animationName) {
      let animationElement = document.getElementById(animationName);
      /* バスのドア */ 
      // バスのドア左の開くアニメーション
      if (animationElement.id === 'animation-nobody-door-1') {
        animationElement.setAttribute('animation-mixer', 'loop:once;clampWhenFinished:true;clip:open-1;');
      }
      // バスのドア右の開くアニメーション
      if (animationElement.id === 'animation-nobody-door-2') {
        animationElement.setAttribute('animation-mixer', 'loop:once;clampWhenFinished:true;clip:open-2;');
      }
      /* エレベーターのドア */
      // エレベーターのドア左の開くアニメーション
      if (animationElement.id === 'animation-door-l') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: -1.1;dir: alternate;dur: 2000;loop: false');
      }
      // エレベーターのドア右の開くアニメーション
      if (animationElement.id === 'animation-door-r') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: 1.1;dir: alternate;dur: 2000;loop: false');
      }
      /* 本館（honkan）1号館（1goukan）のドア */
      // honkan 1goukan ドア左の開くアニメーション
      if (animationElement.id === 'animation-door-1') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: 1;dir: alternate;dur: 2000;loop: false');
      }
      // honkan 1goukan ドア右の開くアニメーション
      if (animationElement.id === 'animation-door-2') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: -1;dir: alternate;dur: 2000;loop: false');
      }
      /* アバター */
      // アバター1 アニメーション
      if (animationElement.id === 'animation-avatar-1') {
        animationElement.setAttribute('animation-mixer', 'loop:true;clampWhenFinished:true;clip:avatar-1;');
      }
      /* 矢印 */
      // 建物内の矢印を前後に動かす
      if (animationElement.id === 'animation-nobody-arrow') {
        animationElement.setAttribute('animation', 'property: object3D.position.z;to: -0.5;dir: alternate;dur: 1000;loop: true');
      }
      if (animationElement.id === 'animation-nobody-arrow1') {
        animationElement.setAttribute('animation', 'property: object3D.position.z;to: -0.5;dir: alternate;dur: 1000;loop: true');
      }
      if (animationElement.id === 'animation-nobody-arrow2') {
        animationElement.setAttribute('animation', 'property: object3D.position.z;to: 0.5;dir: alternate;dur: 1000;loop: true');
      }
      if (animationElement.id === 'animation-nobody-arrow3') {
        animationElement.setAttribute('animation', 'property: object3D.position.x;to: -0.5;dir: alternate;dur: 1000;loop: true');
      }
      /* ワープゾーン */
      // ワープのピンを設定
      if (animationElement.id === 'animation-nobody-mark') {
        // // 原点にあるものは削除(削除するとmassエラーが出るため)
        // animationElement.remove();
        // 原点にあるものは非表示
        animationElement.setAttribute('visible', 'false');
        // glbファイルの保存先URLを取得
        const glbWarpPath = this.glbData.animation[animationElement.id].path;
        if (!glbWarpPath) return;   // 取得できない場合は処理終了
        // ワープGLBを配置する処理
        const scene = document.getElementById('scene');
        // 設定ファイルのワープリストが存在するだけ繰り返す
        for (const property in this.jsonData.warpList) {
          const warpData = this.jsonData.warpList[property];

          // 設定ファイルのmark が "none" の場合はピンを表示しない
          if (warpData.mark === 'none') continue;

          // ワープのentityを作成して配置
          const warpEntity = document.createElement('a-entity');
          warpEntity.setAttribute('id', property);
          warpEntity.setAttribute('static-body', 'shape:none;');
          warpEntity.setAttribute('gltf-model', glbWarpPath);
          const y = typeof warpData.position.y === 'number' ? warpData.position.y : 0;
          warpEntity.setAttribute('position', warpData.position);
          warpEntity.setAttribute(
            'animation',
            `property: object3D.position.y; from: ${y}; to: ${y - 0.3}; dir: alternate; dur: 1000; loop: true`
          );
          if (warpData.rotation) warpEntity.setAttribute('rotation', warpData.rotation);
          scene.appendChild(warpEntity);
        }
      }
    }
  }
}
</script>

<style scoped>
.contents {
  height: 100vh;
}

.vr-scene {
  height: 92vh;
}

.top-menu {
  height: 8vh;
  min-height: calc(50px + 10px);
  display: flex;
}

.top-menu-logo {
  cursor: pointer;
  align-self: center;
  width: auto;
  max-height: 100%;
  margin-left: 10px;
  padding: 5px 0;
}

.menu-icon {
  display: block;
  max-width: 100%;
  width: 1.25em;
}

.menu-icon .cls-1 {
  fill: #fff;
}

.menu-icon .cls-2 {
  fill: #e4100e;
}

.top-menu-right {
  position: relative;
  display: flex;
  font-size: 100%;
  padding: 5px 0;
  margin-left: auto;
}

.menu-button {
  background-color: #ffffff;
  margin: auto 10px auto 0;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all ease 0.2s;
}

.button-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.box-button {
  color: #e4100e;
  font-weight: bold;
  border: 1px solid #e4100e;
  border-radius: 2px;
  padding: 12px 25px;
}

.box-button:hover {
  color: #fff;
  background-color: #e4100e;
  border-color: #e4100e;
}

.box-button:hover a.button-content {
  color: #fff;
}

.box-button:hover .menu-icon .cls-1 {
  fill: #e4100e;
}

.box-button:hover .menu-icon .cls-2 {
  fill: #fff;
}

a.button-content {
  color: #e4100e;
  text-decoration: none;
}

.box-button .button-content {
  flex-direction: row;
  gap: 0.5em;
}

.circle-button {
  width: 50px;
  color: #202020;
  line-height: 0.85em;
  border: thin solid #202020;
  border-radius: 50%;
}

.circle-button:hover {
  color: #fff;
  background-color: #202020;
}

.circle-button.volume--on {
  color: #fff;
  background-color: #202020;
}

.circle-button-text {
  font-size: 0.35em;
  white-space: nowrap;
}

@media screen and (max-width:767px) {
  .box-button {
    line-height: 1.25;
    padding: 8px 10px;
    margin-right: 5px;
  }

  .menu-button {
    margin: auto 5px auto 0;
  }

  .box-button .button-content {
    gap: 0.25em;
  }

  .top-menu-logo {
    max-height: 50px;
    margin-left: 5px;
  }
}

@media screen and (max-width:428px) {

  /* SP 縦画面 */

  .box-button svg {
    display: none;
  }

  .circle-button {
    width: 40px;
    height: 40px;
  }

  .top-menu-logo {
    max-height: 40px;
    margin-left: 5px;
  }

  .top-menu-right {
    font-size: 80%;
  }
}
</style>